module.exports = __webpack_public_path__ + "img/bldc_hall2.00a9e749.png";